export default "__VITE_PUBLIC_ASSET__a4e24b52__"